import React from 'react';
import SplashScreen from '../components/SplashScreen';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ProductsSection from '../components/ProductsSection';
import WhyUsSection from '../components/WhyUsSection';
import ContactSection from '../components/ContactSection';
import FAQSection from '../components/FAQSection';
import Footer, { PARTNERS } from '../components/Footer';
import { useLanguage } from '../context/LanguageContext';

const Home = () => {
  const { t } = useLanguage();

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <SplashScreen />
      <Header scrollToSection={scrollToSection} />

      <main>
        <HeroSection scrollToSection={scrollToSection} />
        <ProductsSection scrollToSection={scrollToSection} />
        <WhyUsSection />

        {/* Insurance Partners Banner */}
        <section className="py-12 bg-white border-y border-slate-200 overflow-hidden">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 mb-6">
            <h3 className="text-center text-lg font-semibold text-slate-600">{t('partners_title')}</h3>
          </div>
          <div className="relative flex overflow-hidden">
            <div className="flex animate-scroll-seamless">
              {[0, 1].map(i => (
                <div key={i} className="flex items-center space-x-16 px-8 shrink-0">
                  {PARTNERS.map(name => (
                    <span key={`${name}-${i}`} className="text-2xl font-bold text-slate-700 whitespace-nowrap">{name}</span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </section>

        <FAQSection />
        <ContactSection />
      </main>

      <Footer scrollToSection={scrollToSection} />
    </div>
  );
};

export default Home;
